import styled from 'styled-components';
import { StyledMenuProps } from './Menu.types';
import { srOnly } from '../../../';

export const StyledMenu = styled.nav<StyledMenuProps>`
  ${srOnly}

  ul {
    list-style: none;
    padding: 0;
  }

  .menu-item--is-open {
    & > .menu-item__submenu {
      display: block;
    }
  }
  .menu-item__submenu {
    display: none;
  }

  ${(props) => props.customStyle}
`;
